<template>
    <el-card>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">Inicio</el-breadcrumb-item>
            <el-breadcrumb-item>Usuarios</el-breadcrumb-item>
        </el-breadcrumb>

		<div class="loading" v-if="loading" v-loading="loading"></div>
		<template v-if="!loading">
            <br />
            <app-table-paginate :routeEdit="routeEdit" :routeDelete="true"  :tableQuery="tableData" :tableColumns="headers"></app-table-paginate>
            <br />
            <el-button type="primary" size="medium" @click="nuevoRegistro()">Nuevo <i class="el-icon-circle-plus-outline el-icon-right"></i></el-button>
        </template>
    </el-card>
</template>

<script>
	import ApiService from '@/common/api.service'
	import tablaConPaginador from '@/components/Dashboard/commons/tablaConPaginador'
    import { mapGetters } from "vuex"

    export default {
        name: 'Usuarios',
        components: {
			'app-table-paginate': tablaConPaginador
        },
        computed: {
			...mapGetters(['isAdmin', 'currentUser'])
		},
        created () {

            if(this.currentUser.rol != 1){
                this.currentUser.rol == 3 ? this.$router.replace('/dashboard/proyectos') : this.$router.replace('/dashboard/misinformes');
            }

			this.routeEdit ='/dashboard/form/usuario/'
			this.init()
			this.$root.$on('delete', (id) => {
                this.eliminarRegistro(id)
            })
        },
        data () {
            return  {
				loading: true,
				headers: [{
                    'prop': 'nombre',
                    'label': 'Nombre'
                },
                {
                    'prop': 'user',
                    'label': 'Usuario'
                },
                {
                    'prop': 'name',
                    'label': 'Nivel'
                }],
				field: {},
				tableQuery: {},
				nametable: this.$route.params.table,
				relationship: [],
				routeEdit: null,
                deleterow: false,
                proyectos: []
            }
        },
        watch: {
			$route(to) {
				this.loading = true
				this.tableQuery = {}
				this.headers = []
				this.routeEdit = '/dashboard/form/usuario/'
				this.init()
			}
		},
        methods: {
			init() {

                this.getProjects()
                setTimeout(() => {
                    this.getTableData()
                }, 100);
            },
            nuevoRegistro() {
                this.$router.push('/dashboard/form/usuario/')
            },
            async getProjects(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'select',
                    fields: ['id','proyecto'],
                    table: 'proyectos',
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.proyectos = response.data
                    }else{
                        this.proyectos = []
                    }
                })
            },
            async getTableData() {
                ApiService.post("public/v1", {
					token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'select',
                    fields: ['users.id', 'users.name as nombre', 'users.user', 'users.pass', 'users.level_id', 'levels.name'],
                    table: 'users',
                    order: [' users.id DESC'],
                    inner: ['levels, id, level_id, users'],
                }).then(response => {
                    if(response.data == 'Algo ha fallado'){
                        this.tableData = []
                    }else{
                        this.tableData = response.data
                        this.tableData = response.data.map( (a)=> {
                            this.proyectos.forEach( e => {
                                if(a.project == parseInt(e.id)){
                                    a.project = e.proyecto
                                }else if(a.project == 0){
                                    a.project = 'Proyecto no asignado'
                                }
                            })
                            return a
                        })
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 300);
                })
            },
            async eliminarRegistro (id){
                this.loading = true
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    method: 'DELETE',
                    id: id ,
                    table: 'users',
                }).then(response => {
                    if(response.data == 1){
                        this.$root.$emit('msgSuccess', 'Registro ELIMINADO')
                        setTimeout(() => {
                            this.init()
                        }, 1000);
                    }else{
                        this.$root.$emit('msgError', 'Algo ha fallado')
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Usuarios.vue